import { createContext, useContext, useEffect, useState } from "react";
import { userTracking } from "../services/user-tracking";
import { v4 as uuidv4 } from "uuid";

const UserTrackingContext = createContext(undefined);

export function UserTrackingProvider({ children }) {
  const [trackingId, setTrackingId] = useState(null);

  useEffect(() => {
    const key = "tracking_uuid";
    let id = localStorage.getItem(key);

    if (!id) {
      id = uuidv4();
      localStorage.setItem(key, id);
    }

    setTrackingId(id);
  }, []);

  async function trackEvent({ eventName, role, domain, payload = {} }) {
    if (!trackingId) return;

    try {
      await userTracking({
        eventName,
        role,
        domain,
        payload,
        trackingId,
      });
    } catch (err) {
      console.error("Tracking failed", err);
    }
  }

  return (
    <UserTrackingContext.Provider
      value={{
        trackingId,
        trackEvent,
      }}
    >
      {children}
    </UserTrackingContext.Provider>
  );
}

export function useUserTrackingContext() {
  const context = useContext(UserTrackingContext);

  if (!context) {
    throw new Error(
      "useUserTrackingContext must be used inside UserTrackingProvider"
    );
  }

  return context;
}
